module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAKCAYAAADLhGwXAAAAAXNSR0IArs4c6QAAAItJREFUOBHNlYsJgDAMRIt76WC6lXM4h1v4yQODUKyJCGkPDtvmOI6SxpRu9LKchetF1px9RajPJOl24ZFxk/0o9CLUhxsiYB5a99TQWAj3oSU0ZOmLxkK4Dz1dCqznaCyE+nRWmlbrBF8c4ZrUDBL8aaJom/A40Vio4vM2xqh5UcWHG2My/P0Bhfic9nWwVHRLopgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/Xandr/newMoreIcon-sm.png
// module id = 1745
// module chunks = 0